import React from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import ControlButton from './ControlButton';
import { EditorState } from 'draft-js';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexFlow: 'wrap',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  });

const BLOCK_TYPES = [
  { label: 'H1', style: 'header-one' },
  { label: 'H2', style: 'header-two' },
  { label: 'H3', style: 'header-three' },
  { label: 'H4', style: 'header-four' },
  { label: 'H5', style: 'header-five' },
  { label: 'H6', style: 'header-six' },
  { label: 'Blockquote', style: 'blockquote' },
  { label: 'UL', style: 'unordered-list-item' },
  { label: 'OL', style: 'ordered-list-item' },
  { label: 'Code', style: 'code-block' },
];

const INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD' },
  { label: 'Italic', style: 'ITALIC' },
  { label: 'Underline', style: 'UNDERLINE' },
  { label: 'Monospace', style: 'CODE' },
];

export interface ControlsOwnProps {
  onToggleBlockType: (style: string) => void;
  onToggleInlineStyle: (style: string) => void;
  editorState: EditorState;
  disabled: boolean;
  whiteTheme?: boolean;
  buttonClassName?: string;
}

export type ControlInjectedProps = WithStyles<typeof styles>;
export type ControlProps = ControlsOwnProps & ControlInjectedProps;

class Controls extends React.PureComponent<ControlProps> {
  render() {
    const {
      classes,
      buttonClassName,
      editorState,
      onToggleBlockType,
      onToggleInlineStyle,
      disabled,
      whiteTheme,
    } = this.props;

    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    const currentStyle = editorState.getCurrentInlineStyle();

    return (
      <div className={classes.root}>
        {BLOCK_TYPES.map(type => (
          <ControlButton
            className={buttonClassName}
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            onToggle={onToggleBlockType}
            style={type.style}
            disabled={disabled}
            whiteTheme={whiteTheme}
          />
        ))}
        {INLINE_STYLES.map(style => (
          <ControlButton
            className={buttonClassName}
            key={style.label}
            active={currentStyle.has(style.style)}
            label={style.label}
            onToggle={onToggleInlineStyle}
            style={style.style}
            disabled={disabled}
            whiteTheme={whiteTheme}
          />
        ))}
      </div>
    );
  }
}

export default withStyles(styles)(Controls);
